import React, { Fragment, useState } from 'react'
import { Paper, Typography } from '@mui/material';
import { withRouter } from 'react-router-dom'
import { useStateIfMounted } from 'use-state-if-mounted'
import {
    agregarFC_01AnexoUnidadEnvasado, editarFC_01AnexoUnidadEnvasado,
    /*agregarFC_01AnexoUnidadEnvasadoMap,
    eliminarFC_01AnexoEnvasadoMap,
    eliminarDataElementoBD,
    eliminarResponsableBD,
    editarFC_01AnexoInstalacion,*/
    agregarFC_36AnexoInstalacion,// obtenerFC_01SolicitudDetalleConFiles,
    obtenerSeccionesEnvasado,
    actualizarFC_36NumeroDeUnidades,
    editarFC_36AnexoInstalacion
    //actualizarInstalaciones
} from '../../../redux/DucksBeneficiario/FC_36Ducks'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid';
import estilos from './FormularioFC01Anexos.module.css'; { {/*Estilos para el componente*/ } }
import Tooltip from '@mui/material/Tooltip';
import ModalComponent from '../../App/ModalComponent'
import GuardarInstalacionComponent from './GuardarInstalacionComponent';
import { obtenerCallesPorClavesEstadoMunicipioLocalidad, obtenerColoniasPorCpApi, obtenerCPsPorMunicipioApi, obtenerEstadosConClaveApi, obtenerLocalidadesPorEstadoYMunicipioApi, obtenerMunicipiosConClavePorEstadoApi, setCallesApi, setCodigosPostalesApi, setColoniasApi, setLocalidadesApi, setMunicipiosApi } from '../../../redux/DucksApis/CopomexDucks';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function FormularioFC36AnexoEnvasadoBeneficiarioComponent(props) {
    const mayor = '>'
    const menor = '<'

    const dispatch = useDispatch()
    var fechaHoy = moment().format('YYYY-MM-DD');

    let idEditable = 0
    const [relacionInstalacion, setRelacionInstalacion] = useState(null)
    const [editInstalacion, setEditInstalacion] = useState(false)
    const [isedicion, setIsEdicion] = useState(false)
    if (props.history.location.state) {
        idEditable = props.history.location.state.idEdit
    }
    React.useEffect(() => {
        if (props.history.location.state?.idEdit) setEditInstalacion(true)
        if (props.history.location.state?.relacioncontacto) {
            setIsEdicion(true)
            setRelacionInstalacion(props.history.location.state?.relacioncontacto)
        }
    }, [])


    let anexoEnvasadoEditable = useSelector(store => store.FC_36Solicitud.instalaciones).filter(anexo => anexo?.data?.id === idEditable)
    const anexoEnvasadoFormato = useSelector(store => store.AtencionSolicitud.formato?.fc_36_anexounidaddeenvasado)?.filter(anexo => anexo.id === idEditable)
    const modoCorreccion = useSelector(store => store.FC_36Solicitud.modoCorreccion)
    const anexoMap = useSelector(store => store.FC_36Solicitud.anexoUnidadMap)
    const anexoResponsablesMap = useSelector(store => store.FC_36Solicitud.anexoResponsableMap)
    const seccionesEnvasado = useSelector(store => store.FC_36Solicitud.seccionesEnvasado)
    let domicilioFiscal = useSelector(store => store.FC_36Solicitud.domicilioFiscal)
    const numeroDeUnidades = useSelector(store => store.FC_36Solicitud.numeroDeUnidades)

    //Municipios y estados validos
    const estadosDenominacionOrigen = useSelector(store => store.FC_36Solicitud.estadosDenominacionOrigen)
    const estadosDenominacion = useSelector(store => store.FC_36Solicitud.estadosDenominacion)
    const municipiosTamaulipas = useSelector(store => store.FC_36Solicitud.municipiosTamaulipas)
    const municipiosGuanajuato = useSelector(store => store.FC_36Solicitud.municipiosGuanajuato)
    const municipiosMichoacan = useSelector(store => store.FC_36Solicitud.municipiosMichoacan)
    const municipiosPuebla = useSelector(store => store.FC_36Solicitud.municipiosPuebla)

    //Api domicilio
    const estadosApi = useSelector(store => store.CopomexApi.estados)
    const municipiosApi = useSelector(store => store.CopomexApi.municipios)
    const codigosPostalesApi = useSelector(store => store.CopomexApi.codigosPostales)
    const coloniasApi = useSelector(store => store.CopomexApi.colonias)
    const localidadesApi = useSelector(store => store.CopomexApi.localidades)
    const callesApi = useSelector(store => store.CopomexApi.calles)

    React.useEffect(() => {
        if (idEditable = props.history.location.state?.idEdit === 0) {
            anexoEnvasadoEditable = []
            setEditInstalacion(false)
        }
        dispatch(obtenerEstadosConClaveApi())
    }, [props.history.location.state])

    const [nombrerazonsocial, setnombrerazonsocial] = useStateIfMounted('')
    const [dictameninstalaciones, setdictameninstalaciones] = useStateIfMounted(true)
    const [actualizacioninformacion, setactualizacioninformacion] = useStateIfMounted('')
    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const [fechapropuesta, setfechapropuesta] = useStateIfMounted(fechaHoy)
    const [instalacionnumero, setinstalacionnumero] = useStateIfMounted()
    const [tipoinstalacion, settipoinstalacion] = useStateIfMounted('')
    const [alias, setalias] = useStateIfMounted('')
    const [calle, setcalle] = useStateIfMounted('')
    const [otracalle, setotracalle] = useStateIfMounted('')
    const [numeroexterior, setnumeroexterior] = useStateIfMounted('')
    const [numerointerior, setnumerointerior] = useStateIfMounted('')
    const [colonia, setcolonia] = useStateIfMounted('')
    const [localidad, setlocalidad] = useStateIfMounted('')
    const [municipio, setmunicipio] = useStateIfMounted('')
    const [estado, setestado] = useStateIfMounted('')
    let [codigopostal, setcodigopostal] = useStateIfMounted()
    const [referenciascercanas, setreferenciascercanas] = useStateIfMounted('')
    let [telefono, settelefono] = useStateIfMounted('')
    const [correoelectronico, setcorreoelectronico] = useStateIfMounted('')
    const [nombreresponsable, setnombreresponsable] = useStateIfMounted('')
    const [anforasplastico, setanforasplastico] = useStateIfMounted(false)
    const [cantidadanforasplastico, setcantidadanforasplastico] = useStateIfMounted()
    const [capacidadanforasplastico, setcapacidadanforasplastico] = useStateIfMounted()
    const [tambosplasticos, settambosplasticos] = useStateIfMounted(false)
    const [cantidadtambosplasticos, setcantidadtambosplasticos] = useStateIfMounted('')
    const [capacidadtambosplasticos, setcapacidadtambosplasticos] = useStateIfMounted('')
    const [contenedoresplastico1000, setcontenedoresplastico1000] = useStateIfMounted(false)
    const [cantidadcontenedoresplastico100, setcantidadcontenedoresplastico100] = useStateIfMounted()
    const [capacidadcontenedoresplastico10, setcapacidadcontenedoresplastico10] = useStateIfMounted()
    const [contenedoresplastico5000, setcontenedoresplastico5000] = useStateIfMounted(false)
    const [cantidadcontenedoresplastico500, setcantidadcontenedoresplastico500] = useStateIfMounted('')
    const [capacidadcontenedoresplastico50, setcapacidadcontenedoresplastico50] = useStateIfMounted('')
    const [recipientesaceroinoxidable, setrecipientesaceroinoxidable] = useStateIfMounted(false)
    const [cantidadrecipientesaceroinoxida, setcantidadrecipientesaceroinoxida] = useStateIfMounted()
    const [capacidadrecipientesaceroinoxid, setcapacidadrecipientesaceroinoxid] = useStateIfMounted()
    const [otroalmacengraneles, setotroalmacengraneles] = useStateIfMounted('')
    const [opcionotroalmacengraneles, setopcionotroalmacengraneles] = useStateIfMounted('')
    const [cantidadotroalmacengraneles, setcantidadotroalmacengraneles] = useStateIfMounted('')
    const [capacidadotroalmacengraneles, setcapacidadotroalmacengraneles] = useStateIfMounted('')
    const [filtrocartucho, setfiltrocartucho] = useStateIfMounted(false)
    const [cantidadfiltrocartucho, setcantidadfiltrocartucho] = useStateIfMounted()
    let [caracteristicasfiltrocartucho, setcaracteristicasfiltrocartucho] = useStateIfMounted()
    const [filtroprensa, setfiltroprensa] = useStateIfMounted(false)
    const [cantidadfiltroprensa, setcantidadfiltroprensa] = useStateIfMounted()
    let [caracteristicasfiltroprensa, setcaracteristicasfiltroprensa] = useStateIfMounted()
    const [otrofiltracionmezcal, setotrofiltracionmezcal] = useStateIfMounted('')
    const [opcionotrofiltracionmezcal, setopcionotrofiltracionmezcal] = useStateIfMounted('')
    const [cantidadotrofiltracionmezcal, setcantidadotrofiltracionmezcal] = useStateIfMounted('')
    const [caracteristicasotrofiltracionme, setcaracteristicasotrofiltracionme] = useStateIfMounted('')
    const [llenadoramanual, setllenadoramanual] = useStateIfMounted(false)
    const [cantidadllenadoramanual, setcantidadllenadoramanual] = useStateIfMounted('')
    const [capacidadllenadoramanual, setcapacidadllenadoramanual] = useStateIfMounted('')
    const [llenadoraautomatica, setllenadoraautomatica] = useStateIfMounted(false)
    const [cantidadllenadoraautomatica, setcantidadllenadoraautomatica] = useStateIfMounted()
    const [capacidadllenadoraautomatica, setcapacidadllenadoraautomatica] = useStateIfMounted()
    const [otrollenadobotellas, setotrollenadobotellas] = useStateIfMounted(false)
    const [opcionotrollenadobotellas, setopcionotrollenadobotellas] = useStateIfMounted('')
    const [cantidadotrollenadobotellas, setcantidadotrollenadobotellas] = useStateIfMounted()
    const [capacidadotrollenadobotellas, setcapacidadotrollenadobotellas] = useStateIfMounted()
    const [taponadomanual, settaponadomanual] = useStateIfMounted(false)
    const [cantidadtaponadomanual, setcantidadtaponadomanual] = useStateIfMounted('')
    const [capacidadtaponadomanual, setcapacidadtaponadomanual] = useStateIfMounted('')
    const [taponadoautomatico, settaponadoautomatico] = useStateIfMounted(false)
    const [cantidadtaponadoautomatico, setcantidadtaponadoautomatico] = useStateIfMounted()
    const [capacidadtaponadoautomatico, setcapacidadtaponadoautomatico] = useStateIfMounted()
    const [otrotaponadobotellas, setotrotaponadobotellas] = useStateIfMounted('')
    const [opcionotrotaponadobotellas, setopcionotrotaponadobotellas] = useStateIfMounted('')
    const [cantidadotrotaponadobotellas, setcantidadotrotaponadobotellas] = useStateIfMounted('')
    const [capacidadotrotaponadobotellas, setcapacidadotrotaponadobotellas] = useStateIfMounted('')
    const [selladomanual, setselladomanual] = useStateIfMounted(false)
    const [cantidadselladomanual, setcantidadselladomanual] = useStateIfMounted('')
    const [capacidadselladomanual, setcapacidadselladomanual] = useStateIfMounted('')
    const [selladoautomatico, setselladoautomatico] = useStateIfMounted(false)
    const [cantidadselladoautomatico, setcantidadselladoautomatico] = useStateIfMounted()
    const [capacidadselladoautomatico, setcapacidadselladoautomatico] = useStateIfMounted()
    const [otroselladobotellas, setotroselladobotellas] = useStateIfMounted('')
    const [opcionotroselladobotellas, setopcionotroselladobotellas] = useStateIfMounted('')
    const [cantidadotroselladobotellas, setcantidadotroselladobotellas] = useStateIfMounted('')
    const [capacidadotroselladobotellas, setcapacidadotroselladobotellas] = useStateIfMounted('')
    const [etiquetadomanual, setetiquetadomanual] = useStateIfMounted(false)
    const [cantidadetiquetadomanual, setcantidadetiquetadomanual] = useStateIfMounted('')
    const [capacidadetiquetadomanual, setcapacidadetiquetadomanual] = useStateIfMounted('')
    const [etiquetadoautomatico, setetiquetadoautomatico] = useStateIfMounted(false)
    const [cantidadetiquetadoautomatico, setcantidadetiquetadoautomatico] = useStateIfMounted()
    const [capacidadetiquetadoautomatico, setcapacidadetiquetadoautomatico] = useStateIfMounted()
    const [otroetiquetadobotellas, setotroetiquetadobotellas] = useStateIfMounted('')
    const [opcionotroetiquetadobotellas, setopcionotroetiquetadobotellas] = useStateIfMounted('')
    const [cantidadotroetiquetadobotellas, setcantidadotroetiquetadobotellas] = useStateIfMounted('')
    const [capacidadotroetiquetadobotellas, setcapacidadotroetiquetadobotellas] = useStateIfMounted('')
    const [idfc36_solicitudactualizacion, setidfc36_solicitudactualizacion] = useStateIfMounted('')
    const [idiformaciongeneral, setidiformaciongeneral] = useStateIfMounted("")

    const [isValid, setIsValid] = useStateIfMounted(false);
    const [message, setMessage] = useStateIfMounted('');


    const obtenerIdElemento = (data) => {
        for (const elemento of data.seccion.seccion.elementosdeseccion) {
            if (elemento.elemento.nombreelemento === data.valor) {
                return elemento.idelemento
            }
        }
        return null
    }

    //Metodos para seccion 1
    const [opcionesSeleccionadosSeccion1, setOpcionesSeleccionadosSeccion1] = useStateIfMounted([])
    const [seccion1, setSeccion1] = useStateIfMounted([])

    const deleteSeccion1 = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = seccion1.filter(fields => fields.id !== inputField.id)
        setSeccion1(fields)
        const opciones = opcionesSeleccionadosSeccion1.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion1(opciones)
    }
    const handleAddSeccion1 = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setSeccion1([...seccion1, anexo])
    };

    const handleOnChangueSeccion1 = (data) => {
        const input = seccion1.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion1
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion1.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion1([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setSeccion1([...seccion1])
    }


    //Metodos para seccion 2
    const [opcionesSeleccionadosSeccion2, setOpcionesSeleccionadosSeccion2] = useStateIfMounted([])
    const [seccion2, setSeccion2] = useStateIfMounted([])

    const deleteSeccion2 = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = seccion2.filter(fields => fields.id !== inputField.id)
        setSeccion2(fields)
        const opciones = opcionesSeleccionadosSeccion2.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion2(opciones)
    }
    const handleAddSeccion2 = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setSeccion2([...seccion2, anexo])
    };

    const handleOnChangueSeccion2 = (data) => {
        const input = seccion2.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion2
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion2.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion2([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setSeccion2([...seccion2])
    }

    //Metodos para seccion 3
    const [opcionesSeleccionadosSeccion3, setOpcionesSeleccionadosSeccion3] = useStateIfMounted([])
    const [seccion3, setSeccion3] = useStateIfMounted([])

    const deleteSeccion3 = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = seccion3.filter(fields => fields.id !== inputField.id)
        setSeccion3(fields)
        const opciones = opcionesSeleccionadosSeccion3.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion3(opciones)
    }
    const handleAddSeccion3 = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setSeccion3([...seccion3, anexo])
    };

    const handleOnChangueSeccion3 = (data) => {
        const input = seccion3.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion3
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion3.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion3([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setSeccion3([...seccion3])
    }

    //Metodos para seccion 4
    const [opcionesSeleccionadosSeccion4, setOpcionesSeleccionadosSeccion4] = useStateIfMounted([])
    const [seccion4, setSeccion4] = useStateIfMounted([])

    const deleteSeccion4 = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = seccion4.filter(fields => fields.id !== inputField.id)
        setSeccion4(fields)
        const opciones = opcionesSeleccionadosSeccion4.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion4(opciones)
    }
    const handleAddSeccion4 = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setSeccion4([...seccion4, anexo])
    };

    const handleOnChangueSeccion4 = (data) => {
        const input = seccion4.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion4
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion4.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion4([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setSeccion4([...seccion4])
    }

    //Metodos para seccion 5
    const [opcionesSeleccionadosSeccion5, setOpcionesSeleccionadosSeccion5] = useStateIfMounted([])
    const [seccion5, setSeccion5] = useStateIfMounted([])

    const deleteSeccion5 = (inputField) => {
        if (inputField.iddataelemento) {
            dispatch(eliminarDataElementoBD(inputField.iddataelemento))
        }
        const fields = seccion5.filter(fields => fields.id !== inputField.id)
        setSeccion5(fields)
        const opciones = opcionesSeleccionadosSeccion5.filter(fields => fields.nombre !== inputField.opcion)
        setOpcionesSeleccionadosSeccion5(opciones)
    }
    const handleAddSeccion5 = () => {
        let anexo = { id: uuidv4(), opcion: '', cantidad: '', descripcion: '' }
        setSeccion5([...seccion5, anexo])
    };

    const handleOnChangueSeccion5 = (data) => {
        const input = seccion5.filter(field => field.id === data.id)
        if (input.length > 0) {
            let opcionesSeleccionados = opcionesSeleccionadosSeccion5
            if (data.campo === 'opcion' && input[0].opcion !== '') {
                opcionesSeleccionados = opcionesSeleccionadosSeccion5.filter(fields => fields.nombre !== input[0].opcion)
            }
            input[0][data.campo] = data.valor
            if (data.campo === 'opcion') {
                input[0]['idelemento'] = obtenerIdElemento(data)
                input[0]['idseccion'] = data.seccion.idseccion
            }
            setOpcionesSeleccionadosSeccion5([...opcionesSeleccionados, { nombre: data.valor }])
        }
        setSeccion5([...seccion5])
    }


    //Metodos para los responsables
    const [responsables, setResponsables] = useStateIfMounted([])
    const deleteResponsable = (inputField) => {
        if (inputField.idfc_36responsabledeinstalacion) {
            dispatch(eliminarResponsableBD(inputField.idfc_36responsabledeinstalacion))
        }
        const fields = responsables.filter(fields => fields.id !== inputField.id)
        setResponsables(fields)
    }
    const handleAddResponsable = () => {
        let anexo = { id: uuidv4(), nombreresponsable: '', telefono: '', correoelectronico: '', estado: false }
        setResponsables([...responsables, anexo])
    };
    const handleOnChangueResponsable = (data) => {
        const input = responsables.filter(field => field.id === data.id)
        if (input.length > 0) {
            input[0][data.campo] = data.valor
            input[0][data.campo] = data.valor
            if (data.campo === 'correoelectronico') input[0]['estado'] = comprobarEmail(data.valor)
        }
        setResponsables([...responsables])
    }

    React.useEffect(async () => {
        if (anexoEnvasadoEditable.length > 0) {
            const anexo = anexoEnvasadoEditable[0].data
            setactualizacioninformacion(anexo.actualizacioninformacion)
            setalias(anexo.alias)
            setanforasplastico(anexo.anforasplastico)
            setcalle(anexo.calle)
            setcantidadanforasplastico(anexo.cantidadanforasplastico)
            setcantidadcontenedoresplastico100(anexo.cantidadcontenedoresplastico100)
            setcantidadcontenedoresplastico500(anexo.cantidadcontenedoresplastico500)
            setcantidadetiquetadoautomatico(anexo.cantidadetiquetadoautomatico)
            setcantidadetiquetadomanual(anexo.cantidadetiquetadomanual)
            setcantidadfiltrocartucho(anexo.cantidadfiltrocartucho)
            setcantidadfiltroprensa(anexo.cantidadfiltroprensa)
            setcantidadllenadoraautomatica(anexo.cantidadllenadoraautomatica)
            setcantidadllenadoramanual(anexo.cantidadllenadoramanual)
            setcantidadotroalmacengraneles(anexo.cantidadotroalmacengraneles)
            setcantidadotroetiquetadobotellas(anexo.cantidadotroetiquetadobotellas)
            setcantidadotrofiltracionmezcal(anexo.cantidadotrofiltracionmezcal)
            setcantidadotrollenadobotellas(anexo.cantidadotrollenadobotellas)
            setcantidadotroselladobotellas(anexo.cantidadotroselladobotellas)
            setcantidadotrotaponadobotellas(anexo.cantidadotrotaponadobotellas)
            setcantidadrecipientesaceroinoxida(anexo.cantidadrecipientesaceroinoxida)
            setcantidadselladoautomatico(anexo.cantidadselladoautomatico)
            setcantidadselladomanual(anexo.cantidadselladomanual)
            setcantidadtambosplasticos(anexo.cantidadtambosplasticos)
            setcantidadtaponadoautomatico(anexo.cantidadtaponadoautomatico)
            setcantidadtaponadomanual(anexo.cantidadtaponadomanual)
            setcapacidadanforasplastico(anexo.capacidadanforasplastico)
            setcapacidadcontenedoresplastico10(anexo.capacidadcontenedoresplastico10)
            setcapacidadcontenedoresplastico50(anexo.capacidadcontenedoresplastico50)
            setcapacidadetiquetadoautomatico(anexo.capacidadetiquetadoautomatico)
            setcapacidadetiquetadomanual(anexo.capacidadetiquetadomanual)
            setcapacidadllenadoraautomatica(anexo.capacidadllenadoraautomatica)
            setcapacidadllenadoramanual(anexo.capacidadllenadoramanual)
            setcapacidadotroalmacengraneles(anexo.capacidadotroalmacengraneles)
            setcapacidadotroetiquetadobotellas(anexo.capacidadotroetiquetadobotellas)
            setcapacidadotrollenadobotellas(anexo.capacidadotrollenadobotellas)
            setcapacidadotroselladobotellas(anexo.capacidadotroselladobotellas)
            setcapacidadotrotaponadobotellas(anexo.capacidadotrotaponadobotellas)
            setcapacidadrecipientesaceroinoxid(anexo.capacidadrecipientesaceroinoxid)
            setcapacidadselladoautomatico(anexo.capacidadselladoautomatico)
            setcapacidadselladomanual(anexo.capacidadselladomanual)
            setcapacidadtambosplasticos(anexo.capacidadtambosplasticos)
            setcapacidadtaponadoautomatico(anexo.capacidadtaponadoautomatico)
            setcapacidadtaponadomanual(anexo.capacidadtaponadomanual)
            setcaracteristicasfiltrocartucho(anexo.caracteristicasfiltrocartucho)
            setcaracteristicasfiltroprensa(anexo.caracteristicasfiltroprensa)
            setcaracteristicasotrofiltracionme(anexo.caracteristicasotrofiltracionme)
            setcodigopostal(anexo.codigopostal)
            setcolonia(anexo.colonia)
            setcontenedoresplastico1000(anexo.contenedoresplastico1000)
            setcontenedoresplastico5000(anexo.contenedoresplastico500)
            setcorreoelectronico(anexo.correoelectronico)
            setdictameninstalaciones(anexo.dictameninstalaciones)
            setestado(anexo.estado)
            setetiquetadoautomatico(anexo.etiquetadoautomatico)
            setetiquetadomanual(anexo.etiquetadomanual)
            setfechapropuesta(anexo.fechapropuesta)
            setfechasolicitud(anexo.fechasolicitud)
            setfiltrocartucho(anexo.filtrocartucho)
            setfiltroprensa(anexo.filtroprensa)
            setinstalacionnumero(anexo.instalacionnumero)
            setllenadoraautomatica(anexo.llenadoraautomatica)
            setllenadoramanual(anexo.llenadoramanual)
            setlocalidad(anexo.localidad)
            setmunicipio(anexo.municipio)
            setnombrerazonsocial(anexo.nombrerazonsocial)
            setnombreresponsable(anexo.nombreresponsable)
            setnumeroexterior(anexo.numeroexterior)
            setnumerointerior(anexo.numerointerior)
            setopcionotroalmacengraneles(anexo.opcionotroalmacengraneles)
            setopcionotroetiquetadobotellas(anexo.opcionotroetiquetadobotellas)
            setopcionotrofiltracionmezcal(anexo.opcionotrofiltracionmezcal)
            setopcionotrollenadobotellas(anexo.opcionotrollenadobotellas)
            setopcionotroselladobotellas(anexo.opcionotroselladobotellas)
            setopcionotrotaponadobotellas(anexo.opcionotrotaponadobotellas)
            setotroalmacengraneles(anexo.otroalmacengraneles)
            setotroetiquetadobotellas(anexo.otroetiquetadobotellas)
            setotrofiltracionmezcal(anexo.otrofiltracionmezcal)
            setotrollenadobotellas(anexo.otrollenadobotellas)
            setotroselladobotellas(anexo.otroselladobotellas)
            setotrotaponadobotellas(anexo.otrotaponadobotellas)
            setrecipientesaceroinoxidable(anexo.recipientesaceroinoxidable)
            setreferenciascercanas(anexo.referenciascercanas)
            setselladoautomatico(anexo.selladoautomatico)
            setselladomanual(anexo.selladomanual)
            settambosplasticos(anexo.tambosplasticos)
            settaponadoautomatico(anexo.taponadoautomatico)
            settaponadomanual(anexo.taponadomanual)
            // settelefono(anexo.telefono)
            settipoinstalacion(anexo.tipoinstalacion)
            setidfc36_solicitudactualizacion(anexo.idfc36_solicitudactualizacion)
            setidiformaciongeneral(anexo.idiformaciongeneral)
            // if (anexo.correoelectronico !== null) comprobarEmail(anexo.correoelectronico)

            if (anexo.dataSeccion) {
                let auxElementosSeccion1 = []
                for (const elemento of anexo.dataSeccion.seccion1) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion1.push(nuevoElemento)
                }
                setSeccion1(auxElementosSeccion1)

                let auxElementosSeccion2 = []
                for (const elemento of anexo.dataSeccion.seccion2) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion2.push(nuevoElemento)
                }
                setSeccion2(auxElementosSeccion2)

                let auxElementosSeccion3 = []
                for (const elemento of anexo.dataSeccion.seccion3) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion3.push(nuevoElemento)
                }
                setSeccion3(auxElementosSeccion3)

                let auxElementosSeccion4 = []
                for (const elemento of anexo.dataSeccion.seccion4) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion4.push(nuevoElemento)
                }
                setSeccion4(auxElementosSeccion4)

                let auxElementosSeccion5 = []
                for (const elemento of anexo.dataSeccion.seccion5) {
                    const { opcion, cantidad, descripcion, otro, idelemento, idseccion, iddataelemento } = elemento
                    const nuevoElemento = { id: uuidv4(), opcion: opcion, cantidad: cantidad, descripcion: descripcion, otro: otro, idelemento: idelemento, idseccion: idseccion, iddataelemento: iddataelemento }
                    auxElementosSeccion5.push(nuevoElemento)
                }
                setSeccion5(auxElementosSeccion5)

                setOpcionesSeleccionadosSeccion1(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion1)
                setOpcionesSeleccionadosSeccion2(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion2)
                setOpcionesSeleccionadosSeccion3(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion3)
                setOpcionesSeleccionadosSeccion4(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion4)
                setOpcionesSeleccionadosSeccion5(anexo.opcionesSeleccionadas.opcionesSeleccionadosSeccion5)
            }
            if (anexo.responsables) {
                let auxResponsables = []
                for (const responsable of anexo.responsables) {
                    const { nombreresponsable, telefono, correoelectronico, estado, idiformaciongeneral, idfc_36responsabledeinstalacion } = responsable
                    const nuevoResponsable = {
                        id: uuidv4(), nombreresponsable: nombreresponsable, telefono: telefono, correoelectronico: correoelectronico, estado: estado,
                        idiformaciongeneral: idiformaciongeneral, idfc_36responsabledeinstalacion: idfc_36responsabledeinstalacion
                    }
                    auxResponsables.push(nuevoResponsable)
                }
                setResponsables(auxResponsables)
            }
            await dispatch(actualizarLoadingApp_true())
            // const result = await obtenerEstadosConClave()
            await cargarDomicilioApi(anexo)
            await dispatch(actualizarLoadingApp_false())
        } else {
            if (anexoEnvasadoFormato) {
                const anexo = anexoEnvasadoFormato[0]
                setactualizacioninformacion(anexo.actualizacioninformacion)
                setalias(anexo.alias)
                setanforasplastico(anexo.anforasplastico)
                setcalle(anexo.calle)
                setcantidadanforasplastico(anexo.cantidadanforasplastico)
                setcantidadcontenedoresplastico100(anexo.cantidadcontenedoresplastico100)
                setcantidadcontenedoresplastico500(anexo.cantidadcontenedoresplastico500)
                setcantidadetiquetadoautomatico(anexo.cantidadetiquetadoautomatico)
                setcantidadetiquetadomanual(anexo.cantidadetiquetadomanual)
                setcantidadfiltrocartucho(anexo.cantidadfiltrocartucho)
                setcantidadfiltroprensa(anexo.cantidadfiltroprensa)
                setcantidadllenadoraautomatica(anexo.cantidadllenadoraautomatica)
                setcantidadllenadoramanual(anexo.cantidadllenadoramanual)
                setcantidadotroalmacengraneles(anexo.cantidadotroalmacengraneles)
                setcantidadotroetiquetadobotellas(anexo.cantidadotroetiquetadobotellas)
                setcantidadotrofiltracionmezcal(anexo.cantidadotrofiltracionmezcal)
                setcantidadotrollenadobotellas(anexo.cantidadotrollenadobotellas)
                setcantidadotroselladobotellas(anexo.cantidadotroselladobotellas)
                setcantidadotrotaponadobotellas(anexo.cantidadotrotaponadobotellas)
                setcantidadrecipientesaceroinoxida(anexo.cantidadrecipientesaceroinoxida)
                setcantidadselladoautomatico(anexo.cantidadselladoautomatico)
                setcantidadselladomanual(anexo.cantidadselladomanual)
                setcantidadtambosplasticos(anexo.cantidadtambosplasticos)
                setcantidadtaponadoautomatico(anexo.cantidadtaponadoautomatico)
                setcantidadtaponadomanual(anexo.cantidadtaponadomanual)
                setcapacidadanforasplastico(anexo.capacidadanforasplastico)
                setcapacidadcontenedoresplastico10(anexo.capacidadcontenedoresplastico10)
                setcapacidadcontenedoresplastico50(anexo.capacidadcontenedoresplastico50)
                setcapacidadetiquetadoautomatico(anexo.capacidadetiquetadoautomatico)
                setcapacidadetiquetadomanual(anexo.capacidadetiquetadomanual)
                setcapacidadllenadoraautomatica(anexo.capacidadllenadoraautomatica)
                setcapacidadllenadoramanual(anexo.capacidadllenadoramanual)
                setcapacidadotroalmacengraneles(anexo.capacidadotroalmacengraneles)
                setcapacidadotroetiquetadobotellas(anexo.capacidadotroetiquetadobotellas)
                setcapacidadotrollenadobotellas(anexo.capacidadotrollenadobotellas)
                setcapacidadotroselladobotellas(anexo.capacidadotroselladobotellas)
                setcapacidadotrotaponadobotellas(anexo.capacidadotrotaponadobotellas)
                setcapacidadrecipientesaceroinoxid(anexo.capacidadrecipientesaceroinoxid)
                setcapacidadselladoautomatico(anexo.capacidadselladoautomatico)
                setcapacidadselladomanual(anexo.capacidadselladomanual)
                setcapacidadtambosplasticos(anexo.capacidadtambosplasticos)
                setcapacidadtaponadoautomatico(anexo.capacidadtaponadoautomatico)
                setcapacidadtaponadomanual(anexo.capacidadtaponadomanual)
                setcaracteristicasfiltrocartucho(anexo.caracteristicasfiltrocartucho)
                setcaracteristicasfiltroprensa(anexo.caracteristicasfiltroprensa)
                setcaracteristicasotrofiltracionme(anexo.caracteristicasotrofiltracionme)
                setcodigopostal(anexo.codigopostal)
                setcolonia(anexo.colonia)
                setcontenedoresplastico1000(anexo.contenedoresplastico1000)
                setcontenedoresplastico5000(anexo.contenedoresplastico500)
                setcorreoelectronico(anexo.correoelectronico)
                setdictameninstalaciones(anexo.dictameninstalaciones)
                setestado(anexo.estado)
                setetiquetadoautomatico(anexo.etiquetadoautomatico)
                setetiquetadomanual(anexo.etiquetadomanual)
                setfechapropuesta(anexo.fechapropuesta)
                setfechasolicitud(anexo.fechasolicitud)
                setfiltrocartucho(anexo.filtrocartucho)
                setfiltroprensa(anexo.filtroprensa)
                setinstalacionnumero(anexo.instalacionnumero)
                setllenadoraautomatica(anexo.llenadoraautomatica)
                setllenadoramanual(anexo.llenadoramanual)
                setlocalidad(anexo.localidad)
                setmunicipio(anexo.municipio)
                setnombrerazonsocial(anexo.nombrerazonsocial)
                setnombreresponsable(anexo.nombreresponsable)
                setnumeroexterior(anexo.numeroexterior)
                setnumerointerior(anexo.numerointerior)
                setopcionotroalmacengraneles(anexo.opcionotroalmacengraneles)
                setopcionotroetiquetadobotellas(anexo.opcionotroetiquetadobotellas)
                setopcionotrofiltracionmezcal(anexo.opcionotrofiltracionmezcal)
                setopcionotrollenadobotellas(anexo.opcionotrollenadobotellas)
                setopcionotroselladobotellas(anexo.opcionotroselladobotellas)
                setopcionotrotaponadobotellas(anexo.opcionotrotaponadobotellas)
                setotroalmacengraneles(anexo.otroalmacengraneles)
                setotroetiquetadobotellas(anexo.otroetiquetadobotellas)
                setotrofiltracionmezcal(anexo.otrofiltracionmezcal)
                setotrollenadobotellas(anexo.otrollenadobotellas)
                setotroselladobotellas(anexo.otroselladobotellas)
                setotrotaponadobotellas(anexo.otrotaponadobotellas)
                setrecipientesaceroinoxidable(anexo.recipientesaceroinoxidable)
                setreferenciascercanas(anexo.referenciascercanas)
                setselladoautomatico(anexo.selladoautomatico)
                setselladomanual(anexo.selladomanual)
                settambosplasticos(anexo.tambosplasticos)
                settaponadoautomatico(anexo.taponadoautomatico)
                settaponadomanual(anexo.taponadomanual)
                settelefono(anexo.telefono)
                settipoinstalacion(anexo.tipoinstalacion)
            }
        }
    }, [])

    React.useEffect(() => {
        dispatch(obtenerSeccionesEnvasado(2))
    }, [])

    React.useEffect(() => {
        if (instalacionnumero === '' || instalacionnumero === undefined && anexoEnvasadoEditable.length === 0) {
            setinstalacionnumero(numeroDeUnidades + 1)
        }
    }, [])

    const cargarDomicilioApi = async (anexo) => {
        var municipiosConClave = []
        if (anexo.estado !== '') {
            const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(anexo.estado))
            municipiosConClave = result.payload
        }
        if (anexo.municipio !== '') {
            const result = await dispatch(obtenerCPsPorMunicipioApi(anexo.municipio))
        }
        if (anexo.codigopostal !== '') {
            //anexo.codigopostal
            const result = await dispatch(obtenerColoniasPorCpApi(anexo.codigopostal))
        }
        var localidadesConClave = []
        if (anexo.codigopostal !== '') {
            const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: anexo.estado, municipio: anexo.municipio }))
            localidadesConClave = result.payload
        }
        if (anexo.localidad !== '') {
            const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, anexo.estado)
            const clave_municipio = await obtenerClaveDomicilio(municipiosConClave, anexo.municipio, "municipio")
            const clave_localidad = await obtenerClaveDomicilio(localidadesConClave, anexo.localidad, "localidad")
            const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        }
    }

    const [errors, setErrors] = useStateIfMounted({})
    const validarAnexo = () => {
        let errores = {}
        // instalacionnumero, alias, calle, numeroexterior, numerointerior,
        //     colonia, localidad, municipio, estado, codigopostal, referenciascercanas
        const textoError = 'Campo obligratorio'
        if (alias === '') { errores.alias = textoError }
        if (calle === '') { errores.calle = textoError }
        else if (calle === 'Otro' && otracalle === '') { errores.otracalle = textoError }

        if (numeroexterior === '') { errores.numeroexterior = textoError }
        // if (numerointerior === '') { errores.numerointerior = textoError }
        // if (colonia === '') { errores.colonia = textoError }
        if (localidad === '') { errores.localidad = textoError }
        if (municipio === '') { errores.municipio = textoError }
        if (estado === '') { errores.estado = textoError }
        if (codigopostal === '') { errores.codigopostal = textoError }
        if (referenciascercanas === '') { errores.referenciascercanas = textoError }
        setErrors(errores)
        if (JSON.stringify(errores) !== '{}') {
            return false
        }
        if (!validarResponsables()) return false
        if (!validarSecciones()) return false
        return true
    }

    const validarResponsables = () => {
        if (responsables.length === 0) return false
        for (let responsable of responsables) {
            if (responsable.nombre === '' || (responsable.telefono + '') === '' || (responsable.telefono + '').length !== 10 ||
                responsable.correoelectronico === '' || !comprobarEmail(responsable.correoelectronico)) {
                return false
            }
        }
        return true
    }
    const validarSecciones = () => {
        if (!validarSeccion(seccion1)) return false
        if (!validarSeccion(seccion2)) return false
        if (!validarSeccion(seccion3)) return false
        if (!validarSeccion(seccion4)) return false
        if (!validarSeccion(seccion5)) return false

        return true
    }
    const validarSeccion = (seccion) => {
        if (seccion.length === 0) return false
        for (let anexo of seccion) {
            if (anexo.opcion === '' || (anexo.cantidad + '') === '' || anexo.descripcion === '' || anexo.otro === '') {
                return false
            }
        }
        return true
    }

    const validarDomicilio = async (data) => {
        const {
            estado,
            municipio
        } = data

        if (await validarEstadoDenominacionOrigen(estado)) return true
        if (await validarEstadoDenominacion(estado)) {
            switch (estado) {
                case 'Tamaulipas':
                    if (await validarMunicipiosTamaulipas(municipio)) return true
                    break;
                case 'Guanajuato':
                    if (await validarMunicipiosGuanajuato(municipio)) return true
                    break;
                case 'Michoacán de Ocampo':
                    if (await validarMunicipiosMichoacan(municipio)) return true
                    break;
                case 'Puebla':
                    if (await validarMunicipiosPuebla(municipio)) return true
                    break;
                default:
                    break;
            }
        }
        return false
    }

    const validarEstadoDenominacionOrigen = async (estado) => {
        if (estadosDenominacionOrigen.includes(estado)) return true
        return false
    }
    const validarEstadoDenominacion = async (estado) => {
        if (estadosDenominacion.includes(estado)) return true
        return false
    }
    const validarMunicipiosTamaulipas = async (municipio) => {
        if (municipiosTamaulipas.includes(municipio)) return true
        return false
    }
    const validarMunicipiosGuanajuato = async (municipio) => {
        if (municipiosGuanajuato.includes(municipio)) return true
        return false
    }
    const validarMunicipiosMichoacan = async (municipio) => {
        if (municipiosMichoacan.includes(municipio)) return true
        return false
    }
    const validarMunicipiosPuebla = async (municipio) => {
        if (municipiosPuebla.includes(municipio)) return true
        return false
    }

    const botonEditarAnexoEnvasado = async () => {
        telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
        caracteristicasfiltrocartucho = caracteristicasfiltrocartucho != undefined && caracteristicasfiltrocartucho != '' ?
            (caracteristicasfiltrocartucho.toString()) : ('')
        caracteristicasfiltroprensa = caracteristicasfiltroprensa != undefined && caracteristicasfiltroprensa != '' ?
            (caracteristicasfiltroprensa.toString()) : ('')
        const dataSeccion = {
            seccion1,
            seccion2,
            seccion3,
            seccion4,
            seccion5,
        }
        const opcionesSeleccionadas = {
            opcionesSeleccionadosSeccion1,
            opcionesSeleccionadosSeccion2,
            opcionesSeleccionadosSeccion3,
            opcionesSeleccionadosSeccion4,
            opcionesSeleccionadosSeccion5
        }
        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = await validarDomicilio(data)
        if (!isedicion) {
            await dispatch(editarFC_36AnexoInstalacion({
                idanexo: anexoEnvasadoEditable[0].data.idanexo,
                id: idEditable, relacioncontacto: relacionInstalacion,
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia, localidad, municipio,
                estado, codigopostal, referenciascercanas,
                idfc36_solicitudactualizacion, dataSeccion, opcionesSeleccionadas, idiformaciongeneral,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Envasado', isedicion: isedicion, baja: false, alta: true
            }))
        } else {
            await dispatch(editarFC_36AnexoInstalacion({
                idanexo: anexoEnvasadoEditable[0].data.idanexo,
                id: idEditable, relacioncontacto: relacionInstalacion,
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia, localidad, municipio,
                estado, codigopostal, referenciascercanas,
                idfc36_solicitudactualizacion, dataSeccion, opcionesSeleccionadas, idiformaciongeneral,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Envasado', isedicion: isedicion, baja: false, alta: false
            }))
        }
        props.history.push('/fc_36')
    }
    const botonActualizarAnexoEnvasado = async () => {
        telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')

        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = await validarDomicilio(data)
        let datosdireccion = {
            idiformaciongeneral: anexoEnvasadoEditable?.[0]?.data?.idiformaciongeneral, calle: calle, otracalle: otracalle, numeroexterior: numeroexterior, numerointerior: numerointerior,
            colonia: colonia, localidad: localidad, municipio: municipio,
            estado: estado, codigopostal: codigopostal
        }
        await dispatch(actualizarInstalaciones({
            datosdireccion: datosdireccion, responsables: responsables
        }))
        await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc36_solicitudactualizacion))
        props.history.push('/fc_36')
    }

    const botonAgregarAnexoEnvasado = async () => {
        telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
        codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
        caracteristicasfiltrocartucho = caracteristicasfiltrocartucho != undefined && caracteristicasfiltrocartucho != '' ?
            (caracteristicasfiltrocartucho.toString()) : ('')
        caracteristicasfiltroprensa = caracteristicasfiltroprensa != undefined && caracteristicasfiltroprensa != '' ?
            (caracteristicasfiltroprensa.toString()) : ('')
        const dataSeccion = {
            seccion1,
            seccion2,
            seccion3,
            seccion4,
            seccion5,
        }
        const opcionesSeleccionadas = {
            opcionesSeleccionadosSeccion1,
            opcionesSeleccionadosSeccion2,
            opcionesSeleccionadosSeccion3,
            opcionesSeleccionadosSeccion4,
            opcionesSeleccionadosSeccion5,
        }
        let domicilio = ''
        if (calle !== null && calle !== '') {
            if (calle === 'Otro') domicilio += otracalle + ', '
            else domicilio += calle + ', '
        }
        if (colonia !== null && colonia !== '') {
            domicilio += colonia + ', '
        }
        if (localidad !== null && localidad !== '') {
            domicilio += localidad + ', '
        }
        if (municipio !== null && municipio !== '') {
            domicilio += municipio + ', '
        }
        if (estado !== null && estado !== '') {
            domicilio += estado + ', '
        }
        if (codigopostal !== null && codigopostal !== '') {
            domicilio += codigopostal
        }
        if (domicilio === '') domicilio = 'No se asignó un domicilio'

        if (instalacionnumero > numeroDeUnidades) {
            await dispatch(actualizarFC_36NumeroDeUnidades(instalacionnumero))
        }
        const data = { estado: estado, municipio: municipio }
        const estatusDomicilio = await validarDomicilio(data)
        const res = await dispatch(agregarFC_36AnexoInstalacion({
            id: uuidv4(),
            instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia, localidad, municipio,
            estado, codigopostal, referenciascercanas, relacioncontacto: null,
            idfc36_solicitudactualizacion, dataSeccion, opcionesSeleccionadas, domicilio,
            responsables, domiciliodenominacionorigen: estatusDomicilio,
            tipoInstalacion: 'Unidad Envasado', alta: true, baja: false, isedicion: false
        }))

        props.history.push('/fc_36')
    }
    const botonAgregarOtroAnexoEnvasado = async () => {
        if (anexoEnvasadoEditable.length === 0) {
            telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
            codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
            caracteristicasfiltrocartucho = caracteristicasfiltrocartucho != undefined && caracteristicasfiltrocartucho != '' ?
                (caracteristicasfiltrocartucho.toString()) : ('')
            caracteristicasfiltroprensa = caracteristicasfiltroprensa != undefined && caracteristicasfiltroprensa != '' ?
                (caracteristicasfiltroprensa.toString()) : ('')
            const dataSeccion = {
                seccion1,
                seccion2,
                seccion3,
                seccion4,
                seccion5,
            }
            const opcionesSeleccionadas = {
                opcionesSeleccionadosSeccion1,
                opcionesSeleccionadosSeccion2,
                opcionesSeleccionadosSeccion3,
                opcionesSeleccionadosSeccion4,
                opcionesSeleccionadosSeccion5,
            }
            let domicilio = ''
            if (calle !== null && calle !== '') {
                if (calle === 'Otro') domicilio += otracalle + ', '
                else domicilio += calle + ', '
            }
            if (colonia !== null && colonia !== '') {
                domicilio += colonia + ', '
            }
            if (localidad !== null && localidad !== '') {
                domicilio += localidad + ', '
            }
            if (municipio !== null && municipio !== '') {
                domicilio += municipio + ', '
            }
            if (estado !== null && estado !== '') {
                domicilio += estado + ', '
            }
            if (codigopostal !== null && codigopostal !== '') {
                domicilio += codigopostal
            }
            if (domicilio === '') domicilio = 'No se asignó un domicilio'

            if (instalacionnumero > numeroDeUnidades) {
                await dispatch(actualizarFC_36NumeroDeUnidades(instalacionnumero))
            }
            const data = { estado: estado, municipio: municipio }
            const estatusDomicilio = await validarDomicilio(data)
            const res = await dispatch(agregarFC_36AnexoInstalacion({
                id: uuidv4(),
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia, localidad, municipio,
                estado, codigopostal, referenciascercanas, relacioncontacto: null,
                idfc36_solicitudactualizacion, dataSeccion, opcionesSeleccionadas, domicilio,
                responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Envasado', isedicion: isedicion, baja: false, alta: true
            }))
            handleResetAllPropertys()
            setinstalacionnumero(instalacionnumero + 1)
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else {
            telefono = telefono != undefined && telefono != '' ? (telefono.toString()) : ('')
            codigopostal = codigopostal != undefined && codigopostal != '' ? (codigopostal.toString()) : ('')
            caracteristicasfiltrocartucho = caracteristicasfiltrocartucho != undefined && caracteristicasfiltrocartucho != '' ?
                (caracteristicasfiltrocartucho.toString()) : ('')
            caracteristicasfiltroprensa = caracteristicasfiltroprensa != undefined && caracteristicasfiltroprensa != '' ?
                (caracteristicasfiltroprensa.toString()) : ('')
            const dataSeccion = {
                seccion1,
                seccion2,
                seccion3,
                seccion4,
                seccion5,
            }
            const opcionesSeleccionadas = {
                opcionesSeleccionadosSeccion1,
                opcionesSeleccionadosSeccion2,
                opcionesSeleccionadosSeccion3,
                opcionesSeleccionadosSeccion4,
                opcionesSeleccionadosSeccion5
            }
            let domicilio = ''
            if (calle !== null && calle !== '') {
                if (calle === 'Otro') domicilio += otracalle + ', '
                else domicilio += calle + ', '
            }
            if (colonia !== null && colonia !== '') {
                domicilio += colonia + ', '
            }
            if (localidad !== null && localidad !== '') {
                domicilio += localidad + ', '
            }
            if (municipio !== null && municipio !== '') {
                domicilio += municipio + ', '
            }
            if (estado !== null && estado !== '') {
                domicilio += estado + ', '
            }
            if (codigopostal !== null && codigopostal !== '') {
                domicilio += codigopostal
            }
            if (domicilio === '') domicilio = 'No se asignó un domicilio'
            const data = { estado: estado, municipio: municipio }
            const estatusDomicilio = await validarDomicilio(data)
            await dispatch(editarFC_36AnexoInstalacion({
                idanexo: anexoEnvasadoEditable[0].data.idanexo,
                id: idEditable,
                instalacionnumero, alias, calle, otracalle, numeroexterior, numerointerior, colonia, localidad, municipio,
                estado, codigopostal, referenciascercanas, relacioncontacto: relacionInstalacion,
                idfc36_solicitudactualizacion, dataSeccion, opcionesSeleccionadas, idiformaciongeneral,
                domicilio, responsables, domiciliodenominacionorigen: estatusDomicilio,
                tipoInstalacion: 'Unidad Envasado', isedicion: isedicion, baja: false, alta: false
            }))
            handleResetAllPropertys()
            setinstalacionnumero(instalacionnumero + 1)
            idEditable = 0
            anexoEnvasadoEditable = []
            setEditInstalacion(false)
            props.history.location.state.idEdit = undefined
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    //Metodos Api Copomex

    const obtenerEstadosConClave = async () => {
        const result = await dispatch(obtenerEstadosConClaveApi())
        return result.payload
    }
    const obtenerMunicipiosConClave = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerMunicipiosConClavePorEstadoApi(data))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerCodigosPostales = async (municipio) => {
        //get Codigos Postales por municipio
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerCPsPorMunicipioApi(municipio))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerColonias = async (cp) => {
        //get colonia por CP
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerColoniasPorCpApi(cp))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }
    const obtenerLocalidades = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const result = await dispatch(obtenerLocalidadesPorEstadoYMunicipioApi({ estado: data.estado, municipio: data.municipio }))
        await dispatch(actualizarLoadingApp_false())
        return result.payload
    }

    const obtenerCalles = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const clave_estado = await obtenerClaveDomicilioEstado(estadosApi, data.clave_estado)
        const clave_municipio = await obtenerClaveDomicilio(municipiosApi, data.clave_municipio, "municipio")
        const clave_localidad = await obtenerClaveDomicilio(localidadesApi, data.clave_localidad, "localidad")
        const result = await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({ clave_estado: clave_estado, clave_municipio: clave_municipio, clave_localidad: clave_localidad }))
        await dispatch(actualizarLoadingApp_false())
        // await dispatch(obtenerCallesPorClavesEstadoMunicipioLocalidad({clave_estado: data.clave_estado, clave_municipio: data.clave_municipio, clave_localidad: data.clave_localidad}))
        return result.payload
    }

    const obtenerClaveDomicilioEstado = async (array, key) => {
        for (const i in array) {
            if (array[i][0] === key) return array[i][1]
        }
    }
    const obtenerClaveDomicilio = async (array, key, nombre) => {
        for (const i in array) {
            if (array[i][nombre] === key) return array[i]["clave"]
        }
    }

    const handleResetAllPropertys = () => {
        setalias('')
        setcalle('')
        setotracalle('')
        setcodigopostal('')
        setcolonia('')
        setcorreoelectronico('')
        setestado('')
        setlocalidad('')
        setmunicipio('')
        setnumeroexterior('')
        setnumerointerior('')
        setidfc36_solicitudactualizacion('')
        setidiformaciongeneral('')
        setreferenciascercanas('')
        settelefono('')
        setResponsables([])
        setSeccion1([])
        setSeccion2([])
        setSeccion3([])
        setSeccion4([])
        setSeccion5([])
        setOpcionesSeleccionadosSeccion1([])
        setOpcionesSeleccionadosSeccion2([])
        setOpcionesSeleccionadosSeccion3([])
        setOpcionesSeleccionadosSeccion4([])
        setOpcionesSeleccionadosSeccion5([])
    }

    /*const botonRegresarFC_01 = async () => {
        if (modoCorreccion) await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc36_solicitudactualizacion))

        props.history.push('/fc_36')
    }*/
    const botonRegresarFC_36 = async () => {
        /*if (modoCorreccion) {
            await dispatch(obtenerFC_01SolicitudDetalleConFiles(idfc36_solicitudactualizacion))
        }*/
        props.history.push('/fc_36')
    }
    const usarDomicilioFiscal = async () => {
        await dispatch(setMunicipiosApi(domicilioFiscal.municipiosApi))
        await dispatch(setCodigosPostalesApi(domicilioFiscal.codigosPostalesApi))
        await dispatch(setColoniasApi(domicilioFiscal.coloniasApi))
        await dispatch(setLocalidadesApi(domicilioFiscal.localidadesApi))
        await dispatch(setCallesApi(domicilioFiscal.callesApi))

        setcalle(domicilioFiscal.calle)
        setotracalle(domicilioFiscal.otracalle)
        setcodigopostal(domicilioFiscal.codigopostal)
        setcolonia(domicilioFiscal.colonia)
        setestado(domicilioFiscal.estado)
        setlocalidad(domicilioFiscal.localidad)
        setmunicipio(domicilioFiscal.municipioalcaldia)
        setnumeroexterior(domicilioFiscal.numeroexterior)
        setnumerointerior(domicilioFiscal.numerointerior)
    }

    const validateEmail = (event) => {

        const email = event.target.value;
        comprobarEmail(email);

    };

    function comprobarEmail(correo) {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;

        if (correo.match(emailRegex)) {

            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;

            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }

        } else {
            return false
        }

    }
    return (
        <Fragment>
            <div className='container containerFixed' style={{ marginLeft: '8%' }}>
                <div className='row ms-1 mt-1 '>
                    <div className='row mt-2 mb-2'>
                        <div className={`${estilos.botonRegresar} col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mt-4`}>
                            <button
                                onClick={botonRegresarFC_36}
                                className='btn btnNaranja zoom-in-zoom-out'>Regresar</button>
                        </div>

                        <div className='col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8 mt-3'>
                            {!modoCorreccion && !editInstalacion ?
                                <div className='ms-3'><h2 className='ms-5'> Unidad de Envasado</h2></div>
                                : <h4 className='ms-4'><strong>Editando</strong> anexo Unidad de Envasado</h4>
                            }
                        </div>

                    </div>
                    <br />
                    <div className='row align-items-center'> <br /><br />
                        <div className={`${estilos.labelNaranjaInstalacion} row mb-2`}>
                            <div className='col-md-8'>
                                <h5 className='text-end'>Información de la instalación</h5>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3'>
                            <div className="form-floating mb-3">
                                <input
                                    value={instalacionnumero}
                                    onChange={e => setinstalacionnumero(e.target.valueAsNumber)}
                                    type="number"
                                    className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                    id="" placeholder='no. de instalcion' //disabled
                                    onWheel={event => event.currentTarget.blur()} />
                                {/* <span className='text-danger'>{anexoMap?.instalacionnumero}</span> */}
                                <label className='floatingInput'>Instalación número</label>
                            </div>

                        </div>

                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9'>
                            <div className="form-floating mb-3">
                                <input
                                    value={alias} onChange={e => setalias(e.target.value)}
                                    type="text"
                                    className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false ? 'inputValidado' : ''}`}
                                    id="" placeholder='Nombre de la instalacion'
                                    onBlur={validarAnexo} />
                                {errors.alias && <div className="text-danger">{errors.alias}</div>}
                                {/* <span className='text-danger'>{anexoMap?.alias}</span> */}
                                <label className='floatingInput'>Alias: <i>(Asignar un "Alias" para identificar cada instalación, esto permitirá diferenciarlas)</i></label>
                            </div>
                        </div>
                    </div>
                    <div className='row justify-content-start'>

                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">

                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={estado}
                                    onChange={e => {
                                        setestado(e.target.value)
                                        // const { ...newValues } = values
                                        // newValues.estado = e.target.value
                                        setmunicipio('')
                                        setcodigopostal('')
                                        setcolonia('')
                                        setlocalidad('')
                                        setcalle('')
                                        if (e.target.value !== '') obtenerMunicipiosConClave(e.target.value)
                                    }}
                                    name="estado"
                                    onBlur={validarAnexo}
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false} >
                                    <option value="">Seleccione su estado</option>
                                    {
                                        estadosApi?.[0] !== undefined && estadosApi?.map((estado, index) => (
                                            <option key={index} value={`${estado[0]}`}>{`${estado[0]}`}</option>
                                        ))
                                    }
                                </select>
                                {errors.estado && <div className="text-danger">{errors.estado}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Estado</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={municipio}
                                    onChange={e => {
                                        setmunicipio(e.target.value)
                                        setcodigopostal('')
                                        setcolonia('')
                                        setlocalidad('')
                                        setcalle('')
                                        if (e.target.value !== '') obtenerCodigosPostales(e.target.value)
                                    }}
                                    name="municipio"
                                    onBlur={validarAnexo}
                                    disabled={estado === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su municipio</option>
                                    {municipiosApi?.[0] !== undefined && municipiosApi?.map((municipio, index) => (
                                        <option key={index} value={`${municipio.municipio}`}>{`${municipio.municipio}`}</option>
                                    ))
                                    }
                                </select>
                                {errors.municipio && <div className="text-danger">{errors.municipio}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Delegación/Municipio</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={codigopostal}
                                    onChange={e => {
                                        setcodigopostal(e.target.value)
                                        setcolonia('')
                                        setlocalidad('')
                                        setcalle('')
                                        if (e.target.value !== '') obtenerColonias(e.target.value)
                                        if (e.target.value !== '') obtenerLocalidades({ estado: estado, municipio: municipio })
                                    }}
                                    name="codigopostal"
                                    onBlur={validarAnexo}
                                    disabled={municipio === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su código postal</option>
                                    {codigosPostalesApi?.[0] !== undefined && codigosPostalesApi?.map((cp, index) => (
                                        <option key={index} value={`${cp}`}>{`${cp}`}</option>
                                    ))
                                    }
                                </select>
                                {errors.codigopostal && <div className="text-danger">{errors.codigopostal}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Código Postal</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={colonia}
                                    onChange={e => {
                                        setcolonia(e.target.value)
                                    }}
                                    name="colonia"
                                    onBlur={validarAnexo}
                                    disabled={codigopostal === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su colonia</option>
                                    {
                                        coloniasApi?.[0] !== undefined && coloniasApi?.map((colonia, index) => (
                                            <option key={index} value={`${colonia}`}>{`${colonia}`}</option>
                                        ))
                                    }
                                </select>
                                {errors.colonia && <div className="text-danger">{errors.colonia}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Colonia</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={localidad}
                                    onChange={e => {
                                        setlocalidad(e.target.value)
                                        setcalle('')
                                        if (e.target.value !== '') obtenerCalles({ clave_estado: estado, clave_municipio: municipio, clave_localidad: localidad })
                                    }}
                                    name="localidad"
                                    onBlur={validarAnexo}
                                    disabled={codigopostal === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su localidad</option>
                                    {
                                        localidadesApi?.[0] !== undefined && localidadesApi?.map((localidad, index) => (
                                            <option key={index} value={`${localidad.localidad}`}>{`${localidad.localidad}`}</option>
                                        ))
                                    }
                                </select>
                                {errors.localidad && <div className="text-danger">{errors.localidad}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Localidad</label>
                            </div>
                        </div>
                        <div className={`col-xs-12 col-sm-12 ${calle === 'Otro' ? 'col-md-1 col-lg-1 col-xl-1 col-xxl-1' : 'col-md-6 col-lg-6 col-xl-6 col-xxl-6'} `}>
                            <div className="form-floating mb-3">
                                <select className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                    (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    value={calle}
                                    onChange={e => {
                                        setcalle(e.target.value)
                                    }}
                                    name="calle"
                                    onBlur={validarAnexo}
                                    disabled={localidad === '' ? true : (relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                >
                                    <option value="">Seleccione su calle</option>
                                    {
                                        callesApi?.[0] !== undefined && callesApi?.map((calle, index) => (
                                            <option key={index} value={`${calle.nombre_vialidad}`}>{`${calle.nombre_vialidad}`}</option>
                                        ))
                                    }
                                    <option value="Otro">Otro</option>
                                </select>
                                {errors.calle && <div className="text-danger">{errors.calle}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Calle</label>
                            </div>
                        </div>
                        {
                            calle === 'Otro' &&
                            <div className='col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5'>
                                <div className="form-floating mb-3">
                                    <input type="text" id="floatingInput"
                                        className={`form-control ${anexoMap?.length > 0 ? (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                        placeholder='Calle'
                                        name="otracalle"
                                        value={otracalle}
                                        onChange={e => setotracalle(e.target.value)}
                                        onBlur={validarAnexo}
                                        disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                    />
                                    {errors.otracalle && <div className="text-danger">{errors.otracalle}</div>}
                                    {anexoMap?.validacioncheck &&
                                        <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                    }
                                    <label className="label-dark" htmlFor="floatingInput">Especifique</label>
                                </div>
                            </div>
                        }
                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                            <div className="form-floating mb-3">
                                <input
                                    value={numeroexterior} onChange={e => setnumeroexterior(e.target.value)}
                                    type="text" min='0'
                                    className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                        (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Número exterior'
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                    onBlur={validarAnexo} />
                                {errors.numeroexterior && <div className="text-danger">{errors.numeroexterior}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Número exterior</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                            <div className="form-floating mb-3">
                                <input
                                    value={numerointerior} onChange={e => setnumerointerior(e.target.value)}
                                    type="text" min='0'
                                    className={`form-control ${JSON.stringify([]) !== JSON.stringify(anexoMap) ?
                                        (anexoMap?.validacioncheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                    id="" placeholder='Número interior'
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                    onBlur={validarAnexo} />
                                {errors.numerointerior && <div className="text-danger">{errors.numerointerior}</div>}
                                {anexoMap?.validacioncheck &&
                                    <span className={`text-danger`}>{anexoMap?.observacion} </span>
                                }
                                <label className="floatingInput">Numero interior</label>
                            </div>
                        </div>
                        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                            <div className="form-floating mb-3">
                                <input
                                    value={referenciascercanas} onChange={e => setreferenciascercanas(e.target.value)}
                                    type="text" min='0'
                                    className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                    id="" placeholder='Indique los lugares cercanos que permitan localizar con facilidad sus instalaciones, o las calles entre las que se encuentra.'
                                    onBlur={validarAnexo}
                                    disabled={(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false}
                                />
                                {errors.referenciascercanas && <div className="text-danger">{errors.referenciascercanas}</div>}
                                <label className="floatingInput">Referencias cercanas</label>
                            </div>
                        </div>
                    </div>
                    <div className='divRedondeadoNaranja'>
                        <h5 className={`text-center  ${estilos.labelNaranjaInstalacion} mt-3`}>Responsables de la instalación</h5>
                    </div>
                    {
                        responsables.map((inputField, index) => (
                            <div key={index} className='row'>
                                <div className='col-md-4'>
                                    <div className="form-floating mb-3">
                                        <input type="text"
                                            className={`form-control ${anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion
                                                === inputField.idfc_36responsabledeinstalacion)[0]?.validacioncheck !== undefined ? (anexoResponsablesMap?.filter
                                                    (map => map.idfc_36responsabledeinstalacion === inputField.idfc_36responsabledeinstalacion)[0]?.validacioncheck ?
                                                    'inputDenegado' : 'inputValidado') : ('')}`}
                                            onChange={e =>
                                                handleOnChangueResponsable(
                                                    {
                                                        valor: e.target.value,
                                                        id: inputField.id,
                                                        campo: 'nombreresponsable'
                                                    })}
                                            disabled={isedicion}
                                            value={inputField.nombreresponsable}
                                            id="" placeholder='Nombre del responsable'
                                        />
                                        {inputField.nombreresponsable.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                        <label className="floatingInput">Nombre completo del responsable</label>
                                        <span className={`${anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion === inputField?.idfc_36responsabledeinstalacion)[0]?.validacioncheck !== undefined ? (
                                            anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion === inputField?.idfc_36responsabledeinstalacion)[0]?.validacioncheck ? 'text-danger'
                                                : 'text-success') : ('')}`}>{anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion
                                                    === inputField?.idfc_36responsabledeinstalacion)[0]?.validacioncheck ? (anexoResponsablesMap?.filter(map => map?.idfc_36responsabledeinstalacion
                                                        === inputField?.idfc_36responsabledeinstalacion)[0]?.observacion) : ''}</span>
                                    </div>
                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center'>
                                    <div className="form-floating mb-3">
                                        <input type="number"
                                            className={`form-control ${anexoResponsablesMap.length > 0 ? 'inputValidado' : ''}`}
                                            onChange={e => e.target.value.length < 11 ? (
                                                handleOnChangueResponsable(
                                                    {
                                                        valor: e.target.value,
                                                        id: inputField.id,
                                                        campo: 'telefono'
                                                    })) : ''}
                                            disabled={isedicion}
                                            value={inputField.telefono}
                                            id="" placeholder='Telefono'
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                        {inputField.telefono.length < 1 ? (<span className='text-danger'>Campo obligatorio</span>) : inputField.telefono.length !== 10 ? (<span className='text-danger'>Debe contener 10 digitos</span>) : ''}
                                        <label className="floatingInput">Teléfono</label>
                                    </div>

                                </div>
                                <div className='col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 text-center'>
                                    <div className="form-floating mb-3">
                                        <input type="email"
                                            className={`form-control ${anexoResponsablesMap.length > 0 ? 'inputValidado' : ''}`}
                                            onChange={e =>
                                                handleOnChangueResponsable(
                                                    {
                                                        valor: e.target.value,
                                                        id: inputField.id,
                                                        campo: 'correoelectronico'
                                                    })
                                            }
                                            disabled={isedicion}
                                            value={inputField.correoelectronico}
                                            id="" placeholder='Correo'
                                        />
                                        <label className="floatingInput">Correo electrónico</label>
                                        {

                                            inputField.correoelectronico === '' ?
                                                <div className={`message text-danger`}>
                                                    Campo obligatorio
                                                </div>
                                                :
                                                <div key={index} className={`message ${(inputField.estado) ? estilos.success : estilos.error}`}>
                                                    {inputField.estado ? `Correo Válido` : `Verifique la estructura de su correo`}
                                                </div>
                                        }
                                    </div>
                                </div>
                                {(relacionInstalacion != null || relacionInstalacion != undefined) ? '' :
                                    <Fragment>
                                        {!modoCorreccion &&
                                            <div className='col-md-1'>
                                                <ModalComponent api={{ deleteAnexo: deleteResponsable, inputField }} text="un responsable de instalción" />
                                            </div>
                                        }
                                    </Fragment>}
                            </div>
                        ))
                    }
                    {(relacionInstalacion != null || relacionInstalacion != undefined) ? true : false ? '' :
                        <Fragment>
                            {!modoCorreccion &&
                                (
                                    <div className='row justify-content-start'>
                                        <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                            <button className='botonAgregarAnexo col-md-3' onClick={e =>
                                                handleAddResponsable()}>Agregar responsable</button>
                                            {responsables.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                        </div>
                                    </div>

                                )
                            }
                        </Fragment>}
                    <div className='divRedondeadoNaranja mb-3'>
                        <h5 className={`text-center ${estilos.labelNaranjaInstalacion}`}>Descripción de la instalación</h5>
                    </div>

                    <div className='container'>
                        {
                            seccionesEnvasado.map((inputField, index) => (
                                <div key={index} className='row'>
                                    <div className='divBorderNaranja ms-3 me-3'>
                                        <h5 className={`text-center ${estilos.labelSeccion}`}><b>{`${inputField.seccion.nombre}`}</b></h5>
                                    </div>

                                    {
                                        (index === 0) &&

                                        seccion1.map((seccion1, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${seccion1.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={seccion1.opcion}
                                                            onChange={e => handleOnChangueSeccion1(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion1.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion1.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {seccion1.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    seccion1.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueSeccion1(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: seccion1.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={seccion1.otro}
                                                                id="" />
                                                            {(seccion1.otro === '' || seccion1.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion1(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: seccion1.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion1.cantidad}
                                                            id=""
                                                            disabled={seccion1.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion1.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion1(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion1.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion1.descripcion}
                                                            id=""
                                                            disabled={seccion1.opcion === '' ? true : false}
                                                        />
                                                        {seccion1.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Caracteristicas de equipo</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteSeccion1(seccion1)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteSeccion1, inputField: seccion1 }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {
                                        (index === 1) &&

                                        seccion2.map((seccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${seccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={seccion.opcion}
                                                            onChange={e => handleOnChangueSeccion2(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion2.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {seccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    seccion.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueSeccion2(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: seccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={seccion.otro}
                                                                id="" />
                                                            {(seccion.otro === '' || seccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion2(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: seccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.cantidad}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion2(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.descripcion}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Botellas/hora)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteSeccion2(seccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteSeccion2, inputField: seccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {
                                        (index === 2) &&

                                        seccion3.map((seccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${seccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={seccion.opcion}
                                                            onChange={e => handleOnChangueSeccion3(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion3.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {seccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    seccion.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueSeccion3(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: seccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={seccion.otro}
                                                                id="" />
                                                            {(seccion.otro === '' || seccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion3(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: seccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.cantidad}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion3(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.descripcion}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Botellas/hora)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteSeccion3(seccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteSeccion3, inputField: seccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {
                                        (index === 3) &&

                                        seccion4.map((seccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${seccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={seccion.opcion}
                                                            onChange={e => handleOnChangueSeccion4(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion4.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {seccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    seccion.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueSeccion4(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: seccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={seccion.otro}
                                                                id="" />
                                                            {(seccion.otro === '' || seccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion4(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: seccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.cantidad}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion4(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.descripcion}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Botellas/hora)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteSeccion4(seccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteSeccion4, inputField: seccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }
                                    {
                                        (index === 4) &&

                                        seccion5.map((seccion, indexEquipo) => (
                                            <div className='row'>
                                                <div className={`${seccion.opcion === 'Otro' ? 'col-md-2' : 'col-md-5'}`}>
                                                    <div className="form-floating mb-3">
                                                        <select className={`form-select ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            value={seccion.opcion}
                                                            onChange={e => handleOnChangueSeccion5(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'opcion',
                                                                    seccion: inputField
                                                                })}
                                                        >
                                                            <option value="">Seleccione una opción</option>
                                                            {
                                                                inputField.seccion.elementosdeseccion.map((opcion, i) => (
                                                                    // (opcion.seleccionado) ? <option value={`${i + 1}`} disabled={`${opcion.nombre}`} >{`${opcion.nombre}`}</option> : <option value={`${i + 1}`}  >{`${opcion.nombre}`}</option>
                                                                    ((opcionesSeleccionadosSeccion5.filter(fields => fields.nombre === opcion.elemento.nombreelemento)).length > 0) ? <option key={i} value={`${opcion.elemento.nombreelemento}`}
                                                                    //disabled 
                                                                    >{`${opcion.elemento.nombreelemento}`}</option> : <option key={i} value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                    // <option value={`${opcion.elemento.nombreelemento}`}  >{`${opcion.elemento.nombreelemento}`}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {seccion.opcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Equipo</label>
                                                    </div>

                                                </div>
                                                {
                                                    seccion.opcion === 'Otro' &&
                                                    <div className='col-md-3'>
                                                        <div className="form-floating mb-2">
                                                            <input type="text" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                                onChange={e => handleOnChangueSeccion5(
                                                                    {
                                                                        valor: e.target.value,
                                                                        id: seccion.id,
                                                                        campo: 'otro'
                                                                    })}
                                                                placeholder='0'
                                                                value={seccion.otro}
                                                                id="" />
                                                            {(seccion.otro === '' || seccion.otro === undefined) ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                            <label className="floatingInput">Especifique</label>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion5(
                                                                {
                                                                    valor: Number(e.target.value),
                                                                    id: seccion.id,
                                                                    campo: 'cantidad'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.cantidad}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.cantidad === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Cantidad</label>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="form-floating mb-2">
                                                        <input type="number" className={`form-control ${anexoMap?.validacioncheck || anexoMap?.validacioncheck == false > 0 ? 'inputValidado' : ''}`}
                                                            onChange={e => handleOnChangueSeccion5(
                                                                {
                                                                    valor: e.target.value,
                                                                    id: seccion.id,
                                                                    campo: 'descripcion'
                                                                })}
                                                            placeholder='0'
                                                            value={seccion.descripcion}
                                                            id=""
                                                            disabled={seccion.opcion === '' ? true : false}
                                                            onWheel={event => event.currentTarget.blur()} />
                                                        {seccion.descripcion === '' ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                                        <label className="floatingInput">Capacidad (Botellas/hora)</label>
                                                    </div>
                                                </div>
                                                {
                                                    !modoCorreccion &&
                                                    <div className='mt-2 col-md-1 border-secondary'>
                                                        {/* <button className='btn btn-danger' onClick={e =>
                                                            deleteSeccion5(seccion)}>Eliminar</button> */}
                                                        <ModalComponent api={{ deleteAnexo: deleteSeccion5, inputField: seccion }} text="un elemento" />
                                                    </div>
                                                }
                                            </div>

                                        ))
                                    }

                                    <div className='container mb-1'>
                                        {
                                            (index === 0 && !modoCorreccion) &&
                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-1' onClick={e =>
                                                    handleAddSeccion1()}>Agregar</button>
                                                <br />
                                                {seccion1.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            </div>
                                        }
                                        {
                                            (index === 1 && !modoCorreccion) &&
                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-1' onClick={e =>
                                                    handleAddSeccion2()}>Agregar</button>
                                                <br />
                                                {seccion2.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            </div>
                                        }
                                        {
                                            (index === 2 && !modoCorreccion) &&
                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-1' onClick={e =>
                                                    handleAddSeccion3()}>Agregar</button>
                                                <br />
                                                {seccion3.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            </div>
                                        }
                                        {
                                            (index === 3 && !modoCorreccion) &&
                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-1' onClick={e =>
                                                    handleAddSeccion4()}>Agregar</button>
                                                <br />
                                                {seccion4.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            </div>
                                        }
                                        {
                                            (index === 4 && !modoCorreccion) &&
                                            <div className='row justify-content-md-center mb-2 text-center mt-2 border-secondary'>
                                                <button className='botonAgregarElementoAnexo col-md-1' onClick={e =>
                                                    handleAddSeccion5()}>Agregar</button>
                                                <br />
                                                {seccion5.length === 0 ? (<span className='text-danger'>Campo obligatorio</span>) : ''}
                                            </div>
                                        }

                                    </div>
                                    <hr />
                                </div>
                            ))
                        }
                    </div>


                    <div className="row mt-5 ms-2">
                        <br />
                        {
                            anexoEnvasadoEditable.length === 0 ? (
                                <div className='text-center'>
                                    {/* <button
                                            onClick={botonAgregarAnexoEnvasado}
                                            type='submit'
                                            className={`btn  ${estilos.botonUnidad}`}> Guardar
                                        </button> */}
                                    <GuardarInstalacionComponent
                                        guardarInstacion={botonAgregarAnexoEnvasado}
                                        agregarOtraInstalacion={botonAgregarOtroAnexoEnvasado}
                                        unidad={'envasado'}
                                        validarUnidad={validarAnexo}
                                        texto={'Guardar'}
                                    />
                                </div>
                            )
                                : (
                                    <div className='text-center'>

                                        {
                                            !modoCorreccion ?
                                                <GuardarInstalacionComponent
                                                    guardarInstacion={botonEditarAnexoEnvasado}
                                                    agregarOtraInstalacion={botonAgregarOtroAnexoEnvasado}
                                                    unidad={'envasado'}
                                                    validarUnidad={validarAnexo}
                                                    texto={'Guardar cambios'}
                                                />
                                                :
                                                <button
                                                    onClick={() => botonActualizarAnexoEnvasado()}
                                                    type='submit'
                                                    className={`btn btnNaranja`}> Guardar cambios
                                                </button>
                                        }
                                    </div>

                                )
                        }
                    </div>

                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(FormularioFC36AnexoEnvasadoBeneficiarioComponent)
